"use strict";

exports.__esModule = true;
exports.l3ContentTypes = exports.l2ContentTypes = exports.l1ContentTypes = exports.PIM_DATA_SOURCE = exports.CONTENTSTACK_LEVEL = void 0;
const commonContentTypes = ['header', 'footer', 'settings', 'teaser', 'picto_items', 'carousel_ui', 'heading_ui', 'page_heading_ui', 'item_listing_grid', 'item_listing_carousel', 'asset_items', 'fluid_grid_ui', 'lds_settings', 'lds_block', 'lds_page', 'page_block_ui', 'breadcrumbs_ui', 'not_found', 'contact_us_block', 'icon', 'external_link', 'redirects', 'iframe', 'retailers', 'newsletter_block', 'image_plus_text_block', 'accordion', 'accordion_item', 'category', 'search_result_block', 'promo_form_block', 'promo_quiz_block', 'sitemap_block', 'filter', 'country_picker', 'share_block_ui', 'modal_external'];
const l1ContentTypes = [...commonContentTypes, 'l1_products_settings', 'l1_homepage', 'l1_content_page'];
exports.l1ContentTypes = l1ContentTypes;
const l2ContentTypes = [...commonContentTypes, 'l2_content_page', 'l2_product_page', 'variant_labels', 'salsify_text_block', 'salsify_columns_text', 'product_cards_by_category', 'page_cards_by_category', 'info_bar', 'product_cards_by_ref', 'tabs', 'tab', 'media_plus_text_block', 'image_model', 'video', 'page_cards_by_ref', 'local_pim', 'key_value', 'custom_content_model', 'product_comparison'];
exports.l2ContentTypes = l2ContentTypes;
const l3ContentTypes = [...l2ContentTypes.filter(ct => !ct.startsWith('l2')), 'login_register_block', 'add_to_cart_modal', 'auth_settings', 'shopping_cart', 'l3_content_page', 'l3_product_page', 'shopify_block', 'profile', 'l3_header_extension', 'l3_carousel_extension', 'l3_item_listing_carousel', 'quantity_button'];
exports.l3ContentTypes = l3ContentTypes;

let CONTENTSTACK_LEVEL = /*#__PURE__*/function (CONTENTSTACK_LEVEL) {
  CONTENTSTACK_LEVEL["l1"] = "l1";
  CONTENTSTACK_LEVEL["l2"] = "l2";
  CONTENTSTACK_LEVEL["l3"] = "l3";
  return CONTENTSTACK_LEVEL;
}({});

exports.CONTENTSTACK_LEVEL = CONTENTSTACK_LEVEL;

let PIM_DATA_SOURCE = /*#__PURE__*/function (PIM_DATA_SOURCE) {
  PIM_DATA_SOURCE["salsify"] = "salsify";
  PIM_DATA_SOURCE["local"] = "local";
  PIM_DATA_SOURCE["none"] = "none";
  return PIM_DATA_SOURCE;
}({});

exports.PIM_DATA_SOURCE = PIM_DATA_SOURCE;